module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_08 (15).dbd7218.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_08 (15).mp4
// module id = 790
// module chunks = 1